import React, { useEffect, useState } from 'react';
import { BsBuilding, BsConeStriped, BsGearFill, BsHeadset, BsShop } from 'react-icons/bs';
import events from '../../events';
import { locales } from '../../translations/locales';
import Loading from '../Loading';
import { _setText } from '../../controllers/dom';

const GameHomePage = (props) => {
    const { data, ModuleRP, locale, theme } = props;

    const [isPlayable, setIsPlayable] = useState(false);
    const [classGroup, setClassGroup] = useState('');
    const [configActive, setConfigActive] = useState(false);
    const [accessSga, setAccessSga] = useState(false);
    const [accessSgo, setAccessSgo] = useState(false);
    const [accessAssignments, setAccessAssignments] = useState(false);

    useEffect(() => {
        if (data.type !== 'game') {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        } else {
            if (data.buildings.length > 0) {
                setIsPlayable(true);
                setClassGroup(`col-12 gameHomePage flex mx-auto w-25 m-2 p-3 cursor-pointer text-center border border-${theme === 'DARK' ? 'light' : 'dark'}`);
            } else {
                setClassGroup(`col-12 gameHomePage col inline-block m-2 p-3 text-center cursor border border-${theme === 'DARK' ? 'light' : 'dark'}`);
            }
            for (let i = 0; i < data.players.length; i++) {
                const player = data.players[i];
                if (player.name === ModuleRP.userName) {
                    for (let y = 0; y < data.ranks.length; y++) {
                        const rank = data.ranks[y];
                        if (player.ranks.some((e) => e === rank.id) && rank.authorizations.config) {
                            setConfigActive(true);
                        }
                        if (player.ranks.some((e) => e === rank.id) && rank.authorizations.alerts) {
                            setAccessSga(true);
                        }
                        if (player.ranks.some((e) => e === rank.id) && rank.authorizations.operations) {
                            setAccessSgo(true);
                        }
                        if (player.ranks.some((e) => e === rank.id) && rank.authorizations.planning && player.assignments.length > 0) {
                            setAccessAssignments(true);
                        }
                    }
                }
            }
        }
        _setText('screenName', ``);
    }, [data, theme, configActive]);

    return (
        data.type === 'game' ?
            <div className={`container-fluid bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                <div className="row">
                    <div className={classGroup} onClick={isPlayable && accessSga ? () => ModuleRP.sga() : () => { }}>
                        <div className="row">
                            <div className="col">
                                <h2 className={`gameHomeTitleMod-${!isPlayable || !accessSga ? '' : theme === 'DARK' ? 'dark' : 'light'}`}>
                                    {locales[locale].gameHomePage.sgaTitle}
                                </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h1>
                                    <BsHeadset className={`icons${!isPlayable || !accessSga ? '-invalid' : ''} mt-5`} />
                                </h1>
                            </div>
                        </div>
                        {
                            !isPlayable ?
                                (
                                    <div className="row">
                                        <div className="col">
                                            <div className='alert alert-warning m-1 mt-5'>
                                                {locales[locale].gameHomePage.alertConfigure}
                                            </div>
                                        </div>
                                    </div>
                                ) : !accessSga ?
                                    (
                                        <div className="row">
                                            <div className="col">
                                                <div className='alert alert-warning m-1 mt-5'>
                                                    {locales[locale].gameHomePage.alertAccess}
                                                </div>
                                            </div>
                                        </div>
                                    ) : ''
                        }
                    </div>
                    <div className={classGroup} onClick={isPlayable && accessSgo ? () => ModuleRP.sgo() : () => { }}>
                        <div className="row">
                            <div className="col">
                                <h2 className={`gameHomeTitleMod-${!isPlayable || !accessSgo ? '' : theme === 'DARK' ? 'dark' : 'light'}`}>
                                    {locales[locale].gameHomePage.sgoTitle}
                                </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h1>
                                    <BsConeStriped className={`icons${!isPlayable || !accessSgo ? '-invalid' : ''} mt-5`} />
                                </h1>
                            </div>
                        </div>
                        {
                            !isPlayable ?
                                (
                                    <div className="row">
                                        <div className="col">
                                            <div className='alert alert-warning m-1 mt-5'>
                                                {locales[locale].gameHomePage.alertConfigure}
                                            </div>
                                        </div>
                                    </div>
                                ) : !accessSgo ?
                                    (
                                        <div className="row">
                                            <div className="col">
                                                <div className='alert alert-warning m-1 mt-5'>
                                                    {locales[locale].gameHomePage.alertAccess}
                                                </div>
                                            </div>
                                        </div>
                                    ) : ''
                        }
                    </div>
                    <div className={classGroup} onClick={isPlayable && accessAssignments ? () => ModuleRP.assignments() : () => { }}>
                        <div className="row">
                            <div
                                className="col"
                            >
                                <h2 className={`gameHomeTitleMod-${!isPlayable || !accessAssignments ? '' : theme === 'DARK' ? 'dark' : 'light'}`}>
                                    {locales[locale].gameHomePage.assignmentsTitle}
                                </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h1>
                                    <BsBuilding className={`icons${!isPlayable || !accessAssignments ? '-invalid' : ''} mt-5`} />
                                </h1>
                            </div>
                        </div>
                        {
                            !isPlayable ?
                                (
                                    <div className="row">
                                        <div className="col">
                                            <div className='alert alert-warning m-1 mt-5'>
                                                {locales[locale].gameHomePage.alertConfigure}
                                            </div>
                                        </div>
                                    </div>
                                ) : !accessAssignments ?
                                    (
                                        <div className="row">
                                            <div className="col">
                                                <div className='alert alert-warning m-1 mt-5'>
                                                    {locales[locale].gameHomePage.alertAccess}
                                                </div>
                                            </div>
                                        </div>
                                    ) : ''
                        }
                    </div>

                </div>
                <div className="row">
                    <div
                        className={`gameHomePage flex mx-auto w-25 m-2 p-3 cursor-pointer text-center border border-${theme === 'DARK' ? 'light' : 'dark'}`}
                        onClick={() => ModuleRP.shop(data.id)}
                    >
                        <div className="row">
                            <div className="col">
                                <h2 className={`gameHomeTitleMod-${theme === 'DARK' ? 'dark' : 'light'}`}>
                                    {locales[locale].gameHomePage.shop}
                                </h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <h1>
                                    <BsShop className={`icons mt-5`} />
                                </h1>
                            </div>
                        </div>
                    </div>
                    {
                        configActive ?
                            (
                                <div
                                    // eslint-disable-next-line max-len
                                    className={`gameHomePage flex mx-auto w-25 m-2 p-3 cursor-pointer text-center border border-${theme === 'DARK' ? 'light' : 'dark'}`}
                                    onClick={() => ModuleRP.configure(data.id)}
                                >
                                    <h1>
                                        <BsGearFill className={`icons${theme === 'DARK' ? '' : '-light'}`} />
                                    </h1>

                                    <h2 className={`gameHomeTitleMod-${theme === 'DARK' ? 'dark' : 'light'}`}>{locales[locale].gameHomePage.configTitle}</h2>
                                </div>
                            ) :
                            ''
                    }
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default GameHomePage;
